/**
 * CShopPromo Theme JavaScript
 * Converted from React app - vanilla JavaScript implementation
 */

(function() {
  'use strict';

  // Scroll Animation Observer
  function initScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.scroll-animate').forEach(el => {
      observer.observe(el);
    });
  }

  // Initialize Inquiry Cart (Local Storage)
  const InquiryCart = {
    storageKey: 'cshop_inquiry_cart',

    getItems() {
      const items = localStorage.getItem(this.storageKey);
      return items ? JSON.parse(items) : [];
    },

    addItem(item) {
      const items = this.getItems();
      items.push({
        ...item,
        id: Date.now(),
        timestamp: new Date().toISOString()
      });
      localStorage.setItem(this.storageKey, JSON.stringify(items));
      this.updateCount();
      return true;
    },

    removeItem(id) {
      const items = this.getItems();
      const filtered = items.filter(item => item.id !== id);
      localStorage.setItem(this.storageKey, JSON.stringify(filtered));
      this.updateCount();
    },

    clear() {
      localStorage.removeItem(this.storageKey);
      this.updateCount();
    },

    getCount() {
      return this.getItems().length;
    },

    updateCount() {
      const count = this.getCount();
      const countElements = document.querySelectorAll('#inquiry-cart-count, .cart-count');
      countElements.forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }
  };

  // Add to Inquiry Button Handler
  function initAddToInquiryButtons() {
    document.addEventListener('click', function(e) {
      if (e.target.matches('.btn-add-inquiry') || e.target.closest('.btn-add-inquiry')) {
        e.preventDefault();
        const button = e.target.matches('.btn-add-inquiry') ? e.target : e.target.closest('.btn-add-inquiry');
        
        const productId = button.dataset.productId;
        const productTitle = button.dataset.productTitle;

        if (productId && productTitle) {
          InquiryCart.addItem({
            productId: productId,
            productName: productTitle,
            addedAt: new Date().toISOString()
          });

          // Show success message
          showToast(`${productTitle} added to inquiry cart!`, 'success');
        }
      }
    });
  }

  // Toast Notification System
  function showToast(message, type = 'info') {
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      bottom: 2rem;
      right: 2rem;
      background: ${type === 'success' ? '#10b981' : '#dc2626'};
      color: white;
      padding: 1rem 2rem;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      animation: slideInRight 0.3s ease-out;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.animation = 'slideOutRight 0.3s ease-out';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  // Carousel/Slider Functionality
  function initCarousels() {
    const carousels = document.querySelectorAll('.products-carousel-wrapper');
    
    carousels.forEach(wrapper => {
      const prevBtn = wrapper.querySelector('.carousel-prev');
      const nextBtn = wrapper.querySelector('.carousel-next');
      const carousel = wrapper.querySelector('.products-carousel');
      const grid = wrapper.querySelector('.products-grid');

      if (!prevBtn || !nextBtn || !carousel || !grid) return;

      let scrollAmount = 0;
      const cardWidth = 300; // Approximate card width
      const gap = 32; // Gap between cards
      const scrollDistance = cardWidth + gap;

      prevBtn.addEventListener('click', () => {
        scrollAmount = Math.max(0, scrollAmount - scrollDistance);
        grid.style.transform = `translateX(-${scrollAmount}px)`;
      });

      nextBtn.addEventListener('click', () => {
        const maxScroll = grid.scrollWidth - carousel.clientWidth;
        scrollAmount = Math.min(maxScroll, scrollAmount + scrollDistance);
        grid.style.transform = `translateX(-${scrollAmount}px)`;
      });
    });
  }

  // Form Validation Helper
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  // Contact Form Handler
  function initContactForm() {
    const contactForm = document.querySelector('.contact-form');
    if (!contactForm) return;

    contactForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const emailInput = this.querySelector('input[type="email"]');
      if (emailInput && !validateEmail(emailInput.value)) {
        showToast('Please enter a valid email address', 'error');
        emailInput.focus();
        return;
      }

      // Submit form
      this.submit();
    });
  }

  // Smooth Scroll for Anchor Links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Initialize all features when DOM is ready
  function init() {
    initScrollAnimations();
    InquiryCart.updateCount();
    initAddToInquiryButtons();
    initCarousels();
    initContactForm();
    initSmoothScroll();

    // Make InquiryCart available globally
    window.InquiryCart = InquiryCart;
  }

  // Run initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Add CSS for toast animations
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

})();
